import { useMutation } from "@apollo/react-hooks";
import { Empty, message } from "antd";
import moment from "moment";
import React from "react";
import { UPDATE_USER_TASK_NOTIFICATION } from "../../../../Graphql/mutations";
import { Loader } from "../../../Loader";
import Empty_Notification from "../../../../Assets/Images/Empty/Empty_Notification.svg";

const NotificationMenu = ({ userNotificationData, userNotificationDataLoading}) => {

  const [UPDATE_USER_TASK_NOTIFICATION_MUTATION, { loading: isUpdatingTask }] =
    useMutation(UPDATE_USER_TASK_NOTIFICATION);

  const handleRead = async (notification_id) => {
    try {
      const isUpdateSuccessful = await UPDATE_USER_TASK_NOTIFICATION_MUTATION({
        variables: {
          user_id: localStorage.getItem("user_id"),
          notification_id,
        },
      });
      if (isUpdateSuccessful.errors) {
        message.error("Something went wrong...");
      }
    } catch (error) {}
  };

  if (userNotificationDataLoading) {
    return <Loader />;
  }

  return (
    <ul className="notifiactionPopoverList pl-0">
      {userNotificationData &&
      userNotificationData.notification_users.length === 0 ? (
        <Empty image={Empty_Notification} description="No Notification" />
      ) : (
        userNotificationData?.notification_users?.map(
          (notifications, index) => (
            <li
              loading={isUpdatingTask}
              onClick={() => handleRead(notifications.notification_id)}
              key={index}
              className={`${!notifications.is_read ? "unread" : ""}`}
            >
              <div className="d-flex justify-content-between align-items-start">
                <h6> {notifications.notification.title}</h6>
                <div className="time">
                  {moment
                    .tz(
                      notifications.created_at,
                      moment.HTML5_FMT.DATETIME_LOCAL_MS
                    )
                    .fromNow()}
                </div>
              </div>
              <p>{notifications.notification.description}</p>
            </li>
          )
        )
      )}
    </ul>
  );
};

export default NotificationMenu;
